import base from '@paradigm/themes/base';
import media from '@paradigm/themes/media';
const color = require("color");

const TRANSPARENT = 'transparent';

const addStateFunctions = (theme) => ({
    ...theme,
    stateHover: function (colorHover) {
        if (colorHover === TRANSPARENT) {
            return `rgba("${theme.colorState.normal}","${theme.toneValueHover}")`;
        }
        return color(colorHover).mix(color(theme.colorState.normal), theme.toneValueHover).hex();
    },
    stateActive: function (colorActive) {
        if (colorActive === TRANSPARENT) {
            return `rgba("${theme.colorState.normal}","${theme.toneValueActive}")`;
        }
        return color(colorActive).mix(color(theme.colorState.normal), theme.toneValueActive).hex();
    },
    stateFocus: function (colorFocus) {
        if (colorFocus === TRANSPARENT) {
            return `rgba("${theme.colorState.normal}","${theme.toneValueFocus}")`;
        }
        return color(colorFocus).mix(color(theme.colorState.normal), theme.toneValueFocus).hex();
    },
    stateDisabled: function (colorDisabled) {
        return color(colorDisabled).alpha(theme.toneValueBase).rgb().string();
    },
});

const getSubThemeByName = (theme, name) => {
    const result = {};

    Object.keys(theme).forEach((key) => {
        const token = theme[key];
        if (key === 'thresholds') {
            for (const layout in token) {
                result[`layoutWidth${layout[0].toUpperCase()}${layout.slice(1)}`] = token[layout];
            }
            return;
        }

        if (typeof token === 'object' && token[name] !== undefined) {
            result[key] = token[name];
            return;
        }
        if (
            (typeof token === 'object' && token[name] === undefined) || typeof token !== 'object') {
            result[key] = token;
            return;
        }
    });

    return result;
};

const getMultiTheme = (theme, keys) => keys.reduce(
    (acc, key) => ({
        ...acc,
        [key]: (addStateFunctions(getSubThemeByName(theme, key)))
    })
    ,{}
);

const Themes = new Map([
    ['Base', getMultiTheme(base, ['default', 'desktopS'])],
    ['Media', getMultiTheme(media, ['default', 'tablet', 'desktopS'])],
]);

export default Themes;
